import {Tooltip} from 'common/tooltip'
import {StyledFacebookLayoutGeneral__ActionBtn} from './_styled'
import {Text} from '../../../../../common/text'

export const FacebookLayoutGeneral__ActionBtn = ({
  tooltip,
  active,
  icon,
  ...props
}) => {
  return (
    <Tooltip placement="bottom" title={tooltip || ''}>
      <StyledFacebookLayoutGeneral__ActionBtn
        data-active={active ? 'true' : 'false'}
        {...props}
      >
        <Text
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '32px',
            height: '32px',
            borderRadius: '60px',
            cursor: active ? 'default' : 'pointer',
            pointerEvents: active ? 'none' : 'auto',
            backgroundColor: active ? 'rgba(229, 16, 29, 0.1)' : 'transparent',
            textDecoration: 'none',
            margin: 0,
            padding: 0,
            transition: 'background-color 0.2s ease',
          }}
          as="a"
          href={props?.href}
        >
          {icon}
        </Text>
      </StyledFacebookLayoutGeneral__ActionBtn>
    </Tooltip>
  )
}
